import GeneralTab from './GeneralTab';
import './GeneralTab.scss';

export default GeneralTab;
